/**
 * PGSS-5551 — the one configured action an archived row is still allowed to offer.
 *
 * An invoice paid in full is archived automatically, and that is precisely where reversing a
 * payment is needed: a customer's final payment bounces, or was recorded against the wrong
 * invoice. PGSS-5544 configured Reverse Payment for Completed & Paid in Full, but an archived row
 * has every configured action cleared before it is drawn (PGSS-5446), so the option was added for
 * a status whose rows can never display it.
 *
 * This opens up Reverse Payment on **invoices only**. Archived records stay view-only everywhere
 * else — the customer archive, the supplier archive and archived orders are untouched, which is
 * the rule PGSS-5446 and PGSS-5447 were both written to protect.
 *
 * The action is taken from the configured list rather than hardcoded against a status, so it
 * follows the workflow configuration: remove it there and it stops appearing here too.
 *
 * Supplier invoices are excluded deliberately. `getActionStage` maps `supplier-invoices` to the
 * invoice stage, so they inherit the staff invoice action list wholesale — but a reversal puts
 * CUSTOMER orders back and a supplier invoice has none.
 */
export const REVERSE_PAYMENT_UI_ID = 'REVERSE_PAYMENT';

export const archivedInvoiceReversalAction = ({ isArchived, stage, type, actions } = {}) => {
  if (!isArchived) return undefined;
  if (stage !== 'invoice') return undefined;
  if (type === 'supplier-invoices') return undefined;
  if (!Array.isArray(actions)) return undefined;
  return actions.find((action) => action?.ui_id === REVERSE_PAYMENT_UI_ID);
};
